import { Pipe, PipeTransform } from '@angular/core';
import { DataObject } from '@miq/shared-models';
/**
 * if removedAttrName not provided in pipe, '_deleted' is used as default "deleted" flag
 * in a collection of items
 */
const _deletedToken = '_deleted';
/**
 * Reads `removedToken` value in  item
 * @example
 * // given
 * const data = { myFlagAttributeName: false }
 * // when
 * const res = byFalseValuesInAttribute('myFlagAttributeName', data)
 * // then
 * res === true
 */
const byFalseValuesInAttribute =
  (attrName: string, value: any = true) =>
  (data: DataObject) =>
    !(data[attrName] === value);
/**
 * Pipe to hide items in a collection dataSource with attribute `_deleted` in truthy value.
 * (if none is provided)
 * @example
 * {{ [{_deleted: true}, {_deleted: false }] | notRemoved }} // => [{ _deleted:false }]
 *
 * {{ [{x: true}, {x: false}] | hideFlaggedItems }} // => [{x: true}, {x: false}]
 * //by default uses _deleted since none has that value all values are preserved
 *
 * {{ [{x: true}, {x: false}] | hideFlaggedItems: 'x' }} // => [{x: false}]
 */
@Pipe({ name: 'hideFlaggedItems' })
export class HideFlaggedItemsPipe implements PipeTransform {
  transform(dataSource: DataObject[], attributeValue = _deletedToken): DataObject[] {
    const [attrName, attrValue] = attributeValue.split(':');
    return (dataSource ?? []).filter(byFalseValuesInAttribute(attrName, attrValue));
  }
}
